import { Link } from '@postenbring/hedwig-react'
import { Icon } from '../../shared/icon/icon'
import { UserIcon } from '../../shared/icon/user-icon'

export const MenuIconSection = ({ content, login }) => {
    const ServiceIconToIcon = ({ serviceIcon }) => (
        <>
            {serviceIcon === 'adresseendringogoppbevaring' && (
                <Icon variant='location' />
            )}
            {serviceIcon === 'hentested' && <Icon variant='location' />}
            {serviceIcon === 'smarttelefon' && <Icon variant='mobile' />}
            {serviceIcon === 'frimerkertilsamling' && (
                <Icon variant='stampsearch' />
            )}
            {serviceIcon === 'jul' && <Icon variant='christmas' />}
            {serviceIcon === 'kundeservice' && <Icon variant='headset' />}
            {serviceIcon === 'internasjonalt' && <Icon variant='globe' />}
            {serviceIcon === 'person' && <UserIcon />}
        </>
    )

    return (
        <ul className='kp-menu-content-icon-links hds-mt-48-64 hds-mb-40-48'>
            {login &&
                login.map((item, index) => (
                    <li key={index} className='kp-hidden-after-large'>
                        <Link
                            className=''
                            variant='no-underline'
                            icon='leading'
                            key={item.title}
                            href={item.url}
                        >
                            <UserIcon />
                            {item.title}
                        </Link>
                    </li>
                ))}
            {content.map((item, index) => (
                <li key={index}>
                    <Link
                        className=''
                        variant='no-underline'
                        icon='leading'
                        key={item.title}
                        href={item.url}
                    >
                        <ServiceIconToIcon serviceIcon={item.serviceIcon} />
                        {item.title}
                    </Link>
                </li>
            ))}
        </ul>
    )
}
